import type { CapacitorConfig } from '@capacitor/cli';

export const backgroundColor = '#f7f4ea';

const config: CapacitorConfig = {
  appId: 'br.com.tarraf.imob',
  appName: 'TARRAF Imob',
  webDir: 'www',
  android: {
    allowMixedContent: false,
    backgroundColor,
  },
  backgroundColor,
  plugins: {
    SplashScreen: {
      launchShowDuration: 1000,
      launchAutoHide: true,
      backgroundColor,
      androidScaleType: 'CENTER_CROP',
      splashImmersive: false,
    },
  },
};

export default config;
